// src/Pages/Admin/Login.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import client from "../../api/client"; // axios client

const ADMIN_TOKEN_KEY = "admin_token";
const ADMIN_USER_KEY = "admin_user";

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      // POST to admin auth endpoint (you already have correct path)
      const res = await client.post("/api/admin-auth/login", { username, password });

      // Log entire response for debugging (safe to inspect shapes)
      console.log("ADMIN LOGIN raw response:", res);
      const data = res?.data || {};
      console.log("ADMIN LOGIN response body:", data);

      // If server signalled failure
      if (!res || res.status >= 400 || data?.ok === false) {
        throw new Error(data?.error || data?.message || "Login failed");
      }

      // Try several canonical token field names the backend might use
      const token = data.token || data.admin_token || data.access_token || data.accessToken || null;
      const adminObj = data.admin || data.user || data.admin_user || { username };

      // ----------------- inside handleSubmit after you compute `token` and `adminObj` -----------------
      if (token) {
        // persist token + admin user
        try {
          localStorage.setItem(ADMIN_TOKEN_KEY, token);
          localStorage.setItem(ADMIN_USER_KEY, JSON.stringify(adminObj));
        } catch (e) {
          console.warn('AdminLogin: failed to write localStorage', e);
        }

        // Ensure axios client immediately uses this token for subsequent requests
        try {
          if (window?.__appClient) {
            window.__appClient.defaults = window.__appClient.defaults || {};
            window.__appClient.defaults.headers = window.__appClient.defaults.headers || {};
            window.__appClient.defaults.headers.common = window.__appClient.defaults.headers.common || {};
            window.__appClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
          } else {
            // fall back to setting the exported client defaults
            client.defaults = client.defaults || {};
            client.defaults.headers = client.defaults.headers || {};
            client.defaults.headers.common = client.defaults.headers.common || {};
            client.defaults.headers.common['Authorization'] = `Bearer ${token}`;
          }
        } catch (e) {
          console.warn('AdminLogin: could not set axios default Authorization header', e);
        }

        // DEBUG checks — remove later once confirmed working
        try {
          console.log('AdminLogin: stored admin_token =>', localStorage.getItem(ADMIN_TOKEN_KEY));
          console.log('AdminLogin: client Authorization header =>', window.__appClient?.defaults?.headers?.common?.Authorization || client.defaults?.headers?.common?.Authorization);
        } catch (e) { /* ignore */ }
      } else {
        // fallback: persist admin user only (cookie based)
        try { localStorage.setItem(ADMIN_USER_KEY, JSON.stringify(adminObj)); } catch (e) { }
        console.log('AdminLogin: no token returned — relying on cookie-based session');
      }


      navigate("/admin");
    } catch (err) {
      const msg = err?.response?.data?.message || err?.message || "Admin login failed";
      alert(msg);
    } finally {
      setLoading(false);
    }
  }



  return (
    <div style={{ maxWidth: 520, margin: "80px auto", padding: 16 }}>
      <h2>Admin Login</h2>
      <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <input value={username} onChange={(e) => setUsername(e.target.value)} placeholder="Username" required />
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" required />
        <button disabled={loading}>{loading ? "Logging in..." : "Login"}</button>
      </form>
    </div>
  );
}
